module.exports = __webpack_public_path__ + "img/chequeo-medico.fcf706f4.png";